import { css } from 'styled-components';

const PriceStyling = css`
    display: inline-flex;
    gap: ${({ theme }) => theme.Spacing4};
`;

export default PriceStyling;
